import useSWR from 'swr';

import { fetchFromOldApi } from '~/services/Http';
export type CustomEmplDetailData = {
  [key: string]: string;
};

export type EmploymentDetailType = {
  fEmplId: number;
  fEmplDetailStartDate: string;
  fEmplDetailStatus: string;
  fEmplDetailJobGrade?: string;
  fEmplDetailTaxNumber?: string;
  fEmplDetailPersonnelGroup1?: string;
  fEmplDetailPersonnelGroup2?: string;
  fEmplDetailPersonnelGroup3?: string;
  fEmplDetailPersonnelGroup4?: string;
  fEmplDetailPersonnelGroup5?: string;
  fEmplDetailVacBalCalcSixDays: number;
  fEmplDetailCalcHoursBalance: boolean;
  fEmplDetailIsPending?: boolean;
  fEmplSubEnteredTime?: string;
  fEmplUid?: string;
  //@ts-ignore
  //eslint-disable-next-line
  fEmplDetailCustomData?: any;
};

export type ExtendedEmploymentDetailType = EmploymentDetailType & {
  [key: string]: number | boolean | string | undefined;
};

export const useEmploymentDetails = (empId?: number, employmentId?: number) => {
  const { data, isLoading, error } = useSWR(
    !!empId && !!employmentId
      ? ['employmentDetails', empId, employmentId]
      : null,
    ([_key, empId, employmentId]) => getEmploymentsDetail(empId, employmentId),
    { revalidateOnFocus: false },
  );
  return { data, isLoading, error };
};

export const getEmploymentsDetail = (
  iEmpId: number,
  iEmplEmpId: number,
): Promise<EmploymentDetailType[]> => {
  return fetchFromOldApi(
    `/json/employee/${iEmpId}/employment/${iEmplEmpId}/details?period=current`,
  ).then((r) => r.json());
};
